// extracted by mini-css-extract-plugin
export default {"nav-button":"xO_aqx","navButton":"xO_aqx","nav-text":"IbOPh8","navText":"IbOPh8","nav-arrow":"GALLtr","navArrow":"GALLtr","disabled":"fhbLTZ","prev":"FILoLD","next":"A_vVqJ"};